import ChargeHelper, { ChargeConstants } from 'features/Charge/chargeHelper';
import KTFormInput, {
    KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import CustomDropdown2 from 'general/components/Others/CustomDropdown2';
import AppColors from 'general/constants/AppColors';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';

DialogInventoryAddView.propTypes = {
    item: PropTypes.object,
    stationId: PropTypes.string,
    onCancel: PropTypes.func,
    onDone: PropTypes.func,
};

function DialogInventoryAddView({ item, stationId, onCancel, onDone }) {
    // MARK: ---- PROPERTIES ----
    const editMode = !!item;
    const [loading, setLoading] = useState(false);
    const [readyToValidate, setReadyToValidate] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [chargeBrand, setChargeBrand] = useState('');
    const [price, setPrice] = useState('');
    const [quantity, setQuantity] = useState('');
    const [inventoryUnit, setInventoryUnit] = useState(ChargeHelper.Data.inventoryUnitOptions[0]?.value);
    useEffect(() => {
        if (item) {
            setSelectedCategory({
                id: item?.category?.categoryId,
                name: item?.category?.name,
                item: item?.category,
            });
            setChargeBrand(item?.category?.chargeBrand?.name);
            setPrice(item?.price);
            setQuantity(item?.quantity);
            setInventoryUnit(item?.category?.unit);
        }
    }, [item]);

    // MARK: ---- FUNCTIONS ----
    const handleSubmit = async () => {
        setReadyToValidate(true);
        if (
            !selectedCategory ||
            !Utils.isValid(price) ||
            !Utils.isValid(quantity)
        ) {
            ToastHelper.showError('Vui lòng nhập đầy đủ thông tin');
            return;
        }

        if (Utils.isValid(price) && price <= 0) {
            ToastHelper.showError('Giá thiết bị phải lớn hơn 0');
            return;
        }

        if (Utils.isValid(quantity) && quantity <= 0) {
            ToastHelper.showError('Số lượng thiết bị phải lớn hơn 0');
            return;
        }

        let params = {
            name: selectedCategory?.name,
            categoryId: selectedCategory?.id,
            unit: inventoryUnit,
            quantity,
            price,
            stationId,
            images: selectedCategory?.item?.images ?? '',
            description: selectedCategory?.item?.description ?? '',

        };
        params = _.pickBy(params, (value) => value !== null && value !== undefined && value !== '');
        setLoading(true);
        if (!editMode) {
            const res = await ChargeHelper.API.requestCreateChargeInventory(params);
            if (_.isBoolean(res) && res) {
                ToastHelper.showSuccess('Thêm mới thiết bị thành công');
                onDone && onDone();
            } else if (_.isString(res)) {
                ToastHelper.showError(res);
            }
        } else {
            const res = await ChargeHelper.API.requestUpdateChargeInventory(item.inventoryId, params);
            if (_.isBoolean(res) && res) {
                ToastHelper.showSuccess('Chỉnh sửa thông tin thiết bị thành công');
                onDone && onDone();
            } else if (_.isString(res)) {
                ToastHelper.showError(res);
            }
        }
        setLoading(false);
    };

    const dropdownCategoryEl = useMemo(() => {
        return (
            <CustomDropdown2
                id="brandId_dialog"
                name="brandId_dialog"
                ignoreConfirmClick={true}
                toggleElement={
                    <button
                        className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between
                            ${!selectedCategory && readyToValidate
                                ? 'button-invalid'
                                : ''}`}
                        type="button"
                    >
                        {selectedCategory?.name ?? 'Chọn thiết bị'}
                    </button>
                }
                selectedValue={selectedCategory}
                dropdownMenuItems={[{ name: 'Thiết bị', role: 'CATEGORY' }]}
                getSubItems={async (item) => {
                    return ChargeHelper.API.requestGetChargeInventoryCategoryList({
                        page: item?.page || 0,
                        limit: 10,
                        q: item?.q || '',
                    }).then((data) => {
                        return {
                            values: data.categories?.map((row) => ({
                                id: row?.categoryId,
                                name: row?.name,
                                item: row,
                            })),
                            total: data.total,
                        };
                    });
                }}
                dropdownMenuStyle={{ maxHeight: '30vh' }}
                dropdownMenuClassName="overflow-auto w-100"
                onChange={(value) => {
                    setSelectedCategory(value);
                    setChargeBrand(value?.item?.chargeBrand?.name);
                    setPrice(value?.item?.price);
                    setInventoryUnit(value?.item?.unit);
                }}
                isDropdownForm={true}
                titleSearchable={true}
                searchable={true}
                searchFormClassName="mx-3 my-1 search-form-border"
                defaultValue={{
                    name: 'Thiết bị',
                    role: 'CATEGORY',
                }}
                footerEl={
                    <div
                        className="p-4 position-sticky sticky-bottom bg-white"
                        style={{
                            borderTop: `1px solid ${AppColors.gray[300]}`,
                        }}
                    >
                        {UIHelper.buildNegativeButton('Bỏ chọn', () => {
                            setSelectedCategory(null);
                        })}
                    </div>
                }
            />
        );
    }, [selectedCategory, readyToValidate]);

    return (
        <div>
            <div className="row m-0 p-0 px-2 mt-4">
                {/* category */}
                <div className="col-md-6 mb-4 px-2">
                    {UIHelper.buildFormLabel('Thiết bị', true)}
                    {dropdownCategoryEl}
                </div>
                <div className="col-md-6 mb-4 px-2">
                    {UIHelper.buildFormLabel('Hãng sản xuất')}
                    <KTBSDropdown
                        toggleElement={({ showError }) => (
                            <button
                                className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between dropdown-disabled ${showError ? 'button-invalid' : ''}`}
                                type="button"
                            >
                                {chargeBrand?.length ? chargeBrand : 'Chọn hãng sản xuất'}
                            </button>
                        )}
                        selectedValue={chargeBrand}
                        dropdownMenuItems={[]}
                        dropdownMenuStyle={{ maxHeight: '30vh' }}
                        dropdownMenuClassName="overflow-auto w-100"
                        onChange={(value) => setChargeBrand(value)}
                        enableCheckValid={false}
                        isDropdownForm={true}
                        isTouched={readyToValidate}
                        disabled={true}
                    />
                </div>
                {/* price */}
                <div className="col-md-6 mb-4 px-2">
                    {UIHelper.buildFormLabel('Đơn giá (giá bán)', true)}
                    <KTFormInput
                        type={KTFormInputType.currency}
                        unit='VNĐ'
                        placeholder="Nhập giá thiết bị"
                        name="price"
                        value={price}
                        onChange={(value) => {
                            setPrice(value);
                        }}
                        enableCheckValid={readyToValidate}
                        isValid={
                            Utils.isValid(price) && price > 0
                        }
                        isTouched={readyToValidate}
                        feedbackText={readyToValidate && (!Utils.isValid(price) || price <= 0) ? "Giá thiết bị phải lớn hơn 0" : ''}
                    />
                </div>
                {/* quantity */}
                <div className="col-md-6 mb-4 px-2">
                    {UIHelper.buildFormLabel('Số lượng', true)}
                    <KTFormInput
                        type={KTFormInputType.currency}
                        unit={inventoryUnit}
                        placeholder="Nhập số lượng"
                        name="quantity"
                        value={quantity}
                        onChange={(value) => {
                            setQuantity(value);
                        }}
                        enableCheckValid={readyToValidate}
                        isValid={
                            Utils.isValid(quantity) && quantity > 0
                        }
                        isTouched={readyToValidate}
                        feedbackText={readyToValidate && (!Utils.isValid(quantity) || quantity <= 0) ? "Số lượng thiết bị phải lớn hơn 0" : ''}
                    />
                </div>
            </div>
            {/* actions */}
            <div
                className="d-flex align-items-center justify-content-end gap-3 px-4 py-3"
                style={{
                    borderTop: `1px solid ${AppColors.gray[200]}`,
                }}
            >
                {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null)}
                {UIHelper.buildGreenButton(
                    !editMode ? 'Thêm' : 'Cập nhật',
                    handleSubmit,
                    null,
                    false,
                    loading
                )}
            </div>
        </div>
    );
}

export default DialogInventoryAddView;
